import React from "react";
import { ReportNotesSection } from "../../report/ReportNotesSection";
import { ReportRule } from "../../report/ReportRule";
import { PayrollReportEmployeeSection } from "./PayrollReportEmployeeSection";
import { PayrollReportOverallSummarySection } from "./PayrollReportOverallSummarySection";
import "../../report/ReportPreviewDocument.css";

export function PayrollReportDocument({ reportModel }) {
  if (!reportModel) return null;

  if (reportModel.isGrouped) {
    const { sections, notes } = reportModel;

    return (
      <article className="report-preview-document" aria-label="Payroll Report">
        {sections.map((section, index) => (
          <React.Fragment key={section.header?.employeeName || index}>
            {index > 0 && <ReportRule variant="preview" />}
            <PayrollReportEmployeeSection
              sectionModel={section}
              variant="preview"
            />
          </React.Fragment>
        ))}

        <PayrollReportOverallSummarySection
          reportModel={reportModel}
          variant="preview"
        />

        {notes && <ReportNotesSection notes={notes} variant="preview" />}
      </article>
    );
  }

  const { notes } = reportModel;

  return (
    <article className="report-preview-document" aria-label="Payroll Report">
      <PayrollReportEmployeeSection
        sectionModel={reportModel}
        variant="preview"
      />

      {notes && <ReportNotesSection notes={notes} variant="preview" />}
    </article>
  );
}
